<div class="div_venue div_menu_wrapper">
    <div class="pos-title-header">
        <label class="lbl_top">{{'MENU.MY_MENUS' | translate}}</label>
        <button class="create_btn responsive_btn" (click)="createMenu()">
            <span class="hide_mobile">{{'MENU.CREATE_NEW_MENU' | translate}}</span>
            <i class="show_mobile pi pi-plus-circle"></i>
        </button>
    </div>
    <div class="pos-description-header">
      <label>{{'MENU.MAKE_YOUR_MENU' | translate}}</label>
    </div>
    <div class="cards_div_wrapper">
        <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
        <div *ngFor="let menu of listAllMenus" class="menu_div">
            <div>
                <div class="menu_dropdown_helper pe-0 pt-0" #icon (click)="$event.stopPropagation(); menu1.toggle($event)"></div>
                <i class="pi pi-ellipsis-v spam-menu manager-emp-menu" (click)="$event.stopPropagation(); icon.click()"></i>
                <p-menu #menu1 class="edit-menu header-menu" [popup]="true" [model]="items[menu.id]"></p-menu>   
            </div>
            <div class="div_content" (click)="navigateToDetails(menu.id)">
              <label class="w-100 menu-name" title="{{menu.name}}">{{menu.name}}</label>
              <span class="menu-created">{{'MENU.CREATED' | translate}}: {{menu.createDate | date: 'dd-MM-YYYY'}}</span>
            </div>
        </div>
    </div>
</div>
